import * as React from "react";
import { useTealiumEventProperties } from "../../events/events/event-properties-provider.js";
import { useTrackPageView } from "../../events/events/use-track-page-view.js";
const errorSourceMapping = { 404: "404", 500: "Server" };
const useTrackErrorPageView = ({ statusCode }) => {
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const errorPageView = React.useCallback(
    async () => {
      const commonUserProperties = await getCommonUserProperties();
      if (!commonUserProperties) return;
      return Promise.resolve({
        ...commonEventProperties,
        ...commonUserProperties,
        id: "VirtualPage-View",
        Error_Source: errorSourceMapping[statusCode] || `${statusCode}`,
        Error_Code: statusCode === 404 ? "404 - page not found" : `${statusCode}`,
        Error_Details: statusCode === 404 ? window.location.href : "",
        Page_Type: "Error",
        Page_Section1: "Other",
        Page_Section2: `ErrorHttp${statusCode}`
      });
    },
    // Only need to trigger this page view on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getCommonUserProperties]
  );
  useTrackPageView(errorPageView);
};
export {
  useTrackErrorPageView
};
//# sourceMappingURL=use-track-error-page-view.js.map
